import { CountryConfiguration } from './country-configuration.model';
import { cpfValidator } from '../validators/cpf';
import { rutValidator } from '../validators/rut';
import { dniValidator } from '../validators/dni';
import { curpValidator } from '../validators/curp';
import { minLengthDocumentValidator } from '../validators/generic-document';

export const LATAM_COUNTRY_CONFIGS: ReadonlyArray<CountryConfiguration> = [
  {
    code: 'BRA',
    alpha2: 'BR',
    locale: 'pt-BR',
    phonePrefix: '+55',
    phoneMask: '(00) 00000-0000',
    phonePlaceholder: '(11) 99999-9999',
    documentType: 'CPF',
    documentMask: '000.000.000-00',
    documentPlaceholder: '000.000.000-00',
    documentValidator: cpfValidator,
  },
  {
    code: 'ARG',
    alpha2: 'AR',
    locale: 'es',
    phonePrefix: '+54',
    phoneMask: '00 0000-0000',
    phonePlaceholder: '11 1234-5678',
    documentType: 'DNI',
    documentMask: '00.000.000',
    documentPlaceholder: '12.345.678',
    documentValidator: dniValidator,
  },
  {
    code: 'CHL',
    alpha2: 'CL',
    locale: 'es',
    phonePrefix: '+56',
    phoneMask: '0 0000 0000',
    phonePlaceholder: '9 1234 5678',
    documentType: 'RUT',
    documentMask: '00.000.000-A',
    documentPlaceholder: '12.345.678-9',
    documentValidator: rutValidator,
  },
  {
    code: 'URY',
    alpha2: 'UY',
    locale: 'es',
    phonePrefix: '+598',
    phoneMask: '0 000 0000',
    phonePlaceholder: '9 123 4567',
    documentType: 'CI',
    documentMask: '0.000.000-0',
    documentPlaceholder: '1.234.567-8',
    documentValidator: minLengthDocumentValidator(7),
  },
  {
    code: 'PRY',
    alpha2: 'PY',
    locale: 'es',
    phonePrefix: '+595',
    phoneMask: '000 000 000',
    phonePlaceholder: '981 123 456',
    documentType: 'CI',
    documentMask: '0.000.000',
    documentPlaceholder: '1.234.567',
    documentValidator: minLengthDocumentValidator(6),
  },
  {
    code: 'BOL',
    alpha2: 'BO',
    locale: 'es',
    phonePrefix: '+591',
    phoneMask: '00000000',
    phonePlaceholder: '71234567',
    documentType: 'CI',
    documentMask: '0000000',
    documentPlaceholder: '1234567',
    documentValidator: minLengthDocumentValidator(6),
  },
  {
    code: 'PER',
    alpha2: 'PE',
    locale: 'es',
    phonePrefix: '+51',
    phoneMask: '000 000 000',
    phonePlaceholder: '999 123 456',
    documentType: 'DNI',
    documentMask: '00000000',
    documentPlaceholder: '12345678',
    documentValidator: minLengthDocumentValidator(8),
  },
  {
    code: 'ECU',
    alpha2: 'EC',
    locale: 'es',
    phonePrefix: '+593',
    phoneMask: '00 000 0000',
    phonePlaceholder: '99 123 4567',
    documentType: 'CI',
    documentMask: '0000000000',
    documentPlaceholder: '1234567890',
    documentValidator: minLengthDocumentValidator(10),
  },
  {
    code: 'COL',
    alpha2: 'CO',
    locale: 'es',
    phonePrefix: '+57',
    phoneMask: '000 000 0000',
    phonePlaceholder: '300 123 4567',
    documentType: 'CC',
    documentMask: '0000000000',
    documentPlaceholder: '1234567890',
    documentValidator: minLengthDocumentValidator(6),
  },
  {
    code: 'VEN',
    alpha2: 'VE',
    locale: 'es',
    phonePrefix: '+58',
    phoneMask: '000 0000000',
    phonePlaceholder: '412 1234567',
    documentType: 'CI',
    documentMask: '00000000',
    documentPlaceholder: '12345678',
    documentValidator: minLengthDocumentValidator(7),
  },
  {
    code: 'MEX',
    alpha2: 'MX',
    locale: 'es',
    phonePrefix: '+52',
    phoneMask: '00 0000 0000',
    phonePlaceholder: '55 1234 5678',
    documentType: 'CURP',
    documentMask: 'SSSS000000SSSSSSAA',
    documentPlaceholder: 'BADD110313HCMLNS09',
    documentValidator: curpValidator,
  },
  {
    code: 'PAN',
    alpha2: 'PA',
    locale: 'es',
    phonePrefix: '+507',
    phoneMask: '0000-0000',
    phonePlaceholder: '6123-4567',
    documentType: 'CIP',
    documentMask: '0-000-0000',
    documentPlaceholder: '8-123-4567',
    documentValidator: minLengthDocumentValidator(6),
  },
  {
    code: 'CRI',
    alpha2: 'CR',
    locale: 'es',
    phonePrefix: '+506',
    phoneMask: '0000-0000',
    phonePlaceholder: '8123-4567',
    documentType: 'Cédula',
    documentMask: '0-0000-0000',
    documentPlaceholder: '1-1234-5678',
    documentValidator: minLengthDocumentValidator(9),
  },
  {
    code: 'GTM',
    alpha2: 'GT',
    locale: 'es',
    phonePrefix: '+502',
    phoneMask: '0000-0000',
    phonePlaceholder: '5123-4567',
    documentType: 'DPI',
    documentMask: '0000 00000 0000',
    documentPlaceholder: '1234 56789 0123',
    documentValidator: minLengthDocumentValidator(13),
  },
  {
    code: 'HND',
    alpha2: 'HN',
    locale: 'es',
    phonePrefix: '+504',
    phoneMask: '0000-0000',
    phonePlaceholder: '9123-4567',
    documentType: 'DNI',
    documentMask: '0000-0000-00000',
    documentPlaceholder: '0101-1990-12345',
    documentValidator: minLengthDocumentValidator(13),
  },
  {
    code: 'NIC',
    alpha2: 'NI',
    locale: 'es',
    phonePrefix: '+505',
    phoneMask: '0000-0000',
    phonePlaceholder: '8123-4567',
    documentType: 'CI',
    documentMask: '000-000000-0000A',
    documentPlaceholder: '001-010101-0001A',
    documentValidator: minLengthDocumentValidator(14),
  },
  {
    code: 'SLV',
    alpha2: 'SV',
    locale: 'es',
    phonePrefix: '+503',
    phoneMask: '0000-0000',
    phonePlaceholder: '7123-4567',
    documentType: 'DUI',
    documentMask: '00000000-0',
    documentPlaceholder: '12345678-9',
    documentValidator: minLengthDocumentValidator(9),
  },
  {
    code: 'DOM',
    alpha2: 'DO',
    locale: 'es',
    phonePrefix: '+1',
    phoneMask: '000-000-0000',
    phonePlaceholder: '809-123-4567',
    documentType: 'Cédula',
    documentMask: '000-0000000-0',
    documentPlaceholder: '001-1234567-8',
    documentValidator: minLengthDocumentValidator(11),
  },
];
